// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__Vd8zj","overflowing":"ReadFullNote_overflowing__2xFqd"};